// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__QnJ34","item":"Tabs_item__sH7Ev","isSelected":"Tabs_isSelected__KigYb"};